/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractorJobsList_statusTypes$ref: FragmentReference;
declare export opaque type ContractorJobsList_statusTypes$fragmentType: ContractorJobsList_statusTypes$ref;
export type ContractorJobsList_statusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: ContractorJobsList_statusTypes$ref,
|};
export type ContractorJobsList_statusTypes$data = ContractorJobsList_statusTypes;
export type ContractorJobsList_statusTypes$key = {
  +$data?: ContractorJobsList_statusTypes$data,
  +$fragmentRefs: ContractorJobsList_statusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContractorJobsList_statusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3bc4ae2b5bc2502b852ccd02ff50da33';
module.exports = node;
